import "toastr";

$(document).ready(function () {
  toastr.options = {
    "closeButton"     : true,
    "debug"           : false,
    "positionClass"   : "toast-bottom-right",
    "onclick"         : null,
    "showDuration"    : "300",
    "hideDuration"    : "1000",
    "timeOut"         : 0,
    "extendedTimeOut" : 0,
    "showEasing"      : "swing",
    "hideEasing"      : "linear",
    "showMethod"      : "fadeIn",
    "hideMethod"      : "fadeOut"
  };
  var msg = $('.x-flash').data('flashMsg');
  if (msg) {
    toastr.info(msg);
  }
  msg = $('.x-flash-error').data('flashMsg');
  if (msg) {
    toastr.error(msg);
  }
});
